<template>
	<div class="drawer">
		<el-drawer
		v-if="msg.planId"
		size="80%"
		title="免疫详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row style="padding:10px 20px 0;float: none;font-size: 16px;">
					<el-col :span="8">
						<span class="label">顾客：</span>
						<span class="value">{{msg.memberName}}</span>
					</el-col>
					<el-col :span="8">
						<span class="label">宠物：</span>
						<span class="value">{{msg.petName}}</span>
					</el-col>
					<el-col :span="8">
						<span class="label">宠物种类：</span>
						<span class="value">{{msg.typeName}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:10px 20px 0;float: none;font-size: 16px;">
					<el-col :span="8" style="display: flex;">
						<span class="label">套餐：</span>
						<span class="value">{{msg.servicePackageName}}</span>
					</el-col>
					<el-col :span="8">
						<span class="label">计划：</span>
						<span class="value">{{msg.planName}}</span>
					</el-col>
					<el-col :span="8">
						<span class="label">支付方式：</span>
						<span class="value">
							<span v-if="msg.payType===1">全额支付</span>
							<span v-if="msg.payType===2">计划支付</span>
							<span v-if="msg.payType===3">套餐卡</span>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:10px 20px 0;float: none;font-size: 16px;">
					<el-col :span="8">
						<span class="label">添加人：</span>
						<span class="value">{{msg.createUserName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">创建时间：</span>
						<span class="value">{{$public.FTime(msg.createTime)}}</span>
					</el-col>
				</el-row>
			</div>
			<div style="margin:0 20px;">
				<el-table :data="tableData" style="width: 100%;" default-expand-all row-key="tableKey" :tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}">
					<el-table-column label="名称">
						<template slot-scope="props">
							<span v-if="props.row.goodsList" style="vertical-align: middle;">{{props.row.goodsName}}</span>
						</template>
					</el-table-column>
					<el-table-column label="条码" prop="customCode" width="120">
					</el-table-column>
					<el-table-column label="数量" width="70">
						<template slot-scope="props">
							<div v-if="props.row.goodsList">{{props.row.num}}</div>
						</template>
					</el-table-column>
					<el-table-column label="用量" width="100">
						<template slot-scope="props">
							<div v-if="props.row.goodsList">
								{{props.row.goodsDosage}}
								<span>{{props.row.outUnit}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="规格" width="200">
						<template slot-scope="props">
							<div v-if="props.row.goodsList">{{props.row.skuValue}}</div>
						</template>
					</el-table-column>
					<el-table-column label="价格" width="90">
						<template slot-scope="props">
							<div v-if="props.row.goodsList">{{props.row.price}}</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="60">
						<template slot-scope="props">
							<div v-if="props.row.goodsList">{{props.row.unit}}</div>
						</template>
					</el-table-column>
					<el-table-column label="总金额" width="120">
						<template slot-scope="props">
							<div v-if="props.row.allowWholesale===0">
								<div v-if="props.row.goodsList">{{$public.cheng(props.row.goodsDosage,props.row.price)}}</div>
							</div>
							<div v-else>
								<div v-if="props.row.goodsList">{{$public.cheng(props.row.num,props.row.price)}}</div>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column label="操作" width="120">
						<template slot-scope="props">
							<el-button v-if="props.row.index>-1" type="text" @click="see(props.row)">查看条码</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
			<el-row style="padding:50px 20px 0;float: none;font-size: 16px;">
				<el-col :span="4" :offset="16">
					<span class="label">共计：</span>
					<span class="value">{{total.count}}件</span>
				</el-col>
				<el-col :span="4">
					<span class="label">总计：</span>
					<span class="value">￥{{total.money}}</span>
				</el-col>
			</el-row>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				msg:{},
				total:{
					count:0,
					money:0,
				},
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getMsg(this.curItem.caseNumber)
			})
		},
		methods: {
			handleClose(){
				this.$emit('close')
			},
			// 获取信息
			getMsg(id){
				this.total.count=0;
				this.total.money=0;
				this.$http.get('/api/Case/Detail', {caseNumber:id}).then(res => {
					if (res.code == 0) {
						this.msg = res.data;
						let tableData = res.data.planGoods||[];
						let table = []
						for(let i=0;i<tableData.length;i++){
							tableData[i].goodsList = tableData[i].goodsItemRecords||[];
							if(tableData[i].replaceType!==1){
								table.push(tableData[i]);
							}
						}
						let table2 = this.filterList(table)
						this.tableData = table2;
						for(let i=0;i<this.tableData.length;i++){
							this.total.count = this.total.count+this.tableData[i].num;
							if(this.tableData[i].allowWholesale===0){
								this.total.money = this.$public.jia(this.total.money,this.$public.cheng(this.tableData[i].goodsDosage,this.tableData[i].price))
							}else{
								this.total.money = this.$public.jia(this.total.money,this.$public.cheng(this.tableData[i].num,this.tableData[i].price))
							}
						}
					}
				})
			},
			filterList(tableData){
				let table = [];
				for(let i=0;i<tableData.length;i++){
					let goods = tableData[i];
					if(goods.goodsList==null){
						goods.goodsList=[]
					}
					if(goods.isPay===true){ // 只处理已支付的
						let one = {
							goodsItemsId:goods.itemsId, // 该接口需要
							checkGoods:'',
							"goodsId": goods.goodsId,
							"goodsName": goods.goodsName,
							"goodsType": goods.goodsType,
							skus: goods.skus||goods.goodsId, // 规格 skus
							skuValue: goods.skuValue||'', // 规格 skuValue
							"unit": goods.unit,
							"outUnit": goods.outUnit,
							"allowWholesale": goods.allowWholesale,
							"originalPrice": goods.originalPrice,
							"price": goods.price,
							"num": goods.num,
							"isPay": goods.isPay,
							"activityId": '',
							"activityName": '',
							"totalMoney": '',
							"goodsUsage": goods.goodsUsage,
							"goodsDosage": goods.goodsDosage,
							"goodsList": [],
							"remark": goods.remark,
							extendContent:goods.extendContent?JSON.parse(goods.extendContent):''
						}
						one.tableKey='tableKey_goods_one'+Math.random();
						one.checkGoods = JSON.parse(JSON.stringify(one));
						for(let a=0;a<goods.goodsList.length;a++){
							let two = {
								tableKey:'tableKey_goods_two'+Math.random(),
								"goodsId": goods.goodsList[a].goodsId,
								"goodsName": goods.goodsList[a].goodsName,
								goodsItemsId:goods.itemsId, // 该接口需要
								"customCode": goods.goodsList[a].customBarCode,
								"goodsType": goods.goodsType,
								"goodsDosage": goods.goodsList[a].outDosage,
								skus: goods.skus||goods.goodsId, // 规格 skus
								skuValue: goods.skuValue||'', // 规格 skuValue
								"specificationPrice": 0,
								"price": goods.goodsList[a].price,
								"unit":  goods.unit,
								"outUnit": goods.outUnit,
								"allowWholesale": goods.allowWholesale,
								"validityStopDate": goods.goodsList[a].expiryDate,
								isOut:goods.goodsList[a].isOut,
							}
							one.goodsList.push(two)
						}
						table.push(one);
					}
				}
				return table;
			}
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:100px;text-align: right;flex-shrink: 0;line-height: 24px;
			}
			.value{
				line-height: 24px;
			}
		}
		
	}
	
</style>
